module.exports = __webpack_public_path__ + "img/panel_feature_2_500X.e46c6fc2.jpg";